module.exports = "<div class=\"notification\">\n  <cm-avatar class=\"notification__image\" [image]=\"notification.image\"></cm-avatar>\n  <div class=\"notification__text\">\n    <h2 class=\"notification__title\">{{ notification.title }}</h2>\n    <p class=\"notification__body\">{{ notification.body }}</p>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/notification/notification.component.html
// module id = ../../../../../src/app/notification/notification.component.html
// module chunks = 4